import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Asegúrate de que esta ruta sea correcta

const drawerWidth = 240; // Ancho del menú lateral

const Menu = () => {
  const { logout } = useAuth(); // Usamos el contexto para manejar el logout
  const navigate = useNavigate();

const menuItems = [
  // { text: "Landing Page", icon: <DashboardIcon />, path: "/" }, // Redirige a la landing
  // { text: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
  // { text: "Usuarios", icon: <PeopleIcon />, path: "/usuarios" },
  { text: "Clientes", icon: <PeopleIcon />, path: "/clientes" },
  { text: "Documentos", icon: <PeopleIcon />, path: "/documentos" },
  { text: "Papelería", icon: <PeopleIcon />, path: "/papeleria" },
  { text: "Papelería Vigencia", icon: <PeopleIcon />, path: "/papeleriaVigencia" },
  { text: "Registrar Productos ", icon: <PeopleIcon />, path: "/imagenes" },
  { text: "Ver Productos", icon: <PeopleIcon />, path: "/productos" },
  { text: "Registrar Tenencias", icon: <PeopleIcon />, path: "/registrarTenencias" },
  { text: "Imprimir Tenencias", icon: <PeopleIcon />, path: "/imprimirTenencias" },

];


  const handleLogout = () => {
    logout(); // Llama a la función logout del contexto
    navigate('/'); // Redirige al login
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
        },
      }}
    >
      <Toolbar />
      <List>
        {menuItems.map((item, index) => (
          <ListItem
            button
            key={index}
            component={Link}
            to={item.path}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
        {/* Botón de Cerrar Sesión */}
        <ListItem button onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary="Cerrar Sesión" />
        </ListItem>
      </List>
    </Drawer>
  );
};

export default Menu;
